import React from "react";
import SharedProjectVariablesPage from "~/areas/projects/components/Variables/ProjectVariables/SharedProjectVariablesPage";
export function ProjectVariablesPage() {
    return <SharedProjectVariablesPage />;
}
